<p id="hintNoSupplier" *ngIf="noCatalogSupplier">{{"Im Katalog ist kein Lieferant eingetragen. Makro kann nicht ausgeführt werden."| translate}}</p>
